import React from "react";
import {
  getPreventDefaultHandler,
  someNode,
  useEventPlateId,
  usePlateEditorState,
} from "@udecode/plate-core";
import { ToolbarButton, ToolbarButtonProps } from "@udecode/plate-ui-toolbar";
import { ELEMENT_HANGING_INDENT } from "../createHangingIndentPlugin";
import { toggleHangingIndent } from "../transforms/toggleHangingIndentNodes";
import { allowFeatureForList } from "../../../config/lists";
import { allowFeatureForTextMessages } from "../../text-message/config";

export const HangingIndentToolbarButton = ({
  id,
  ...props
}: ToolbarButtonProps) => {
  const editor = usePlateEditorState(useEventPlateId(id));

  const enabled = allowFeatureForList(editor) && allowFeatureForTextMessages(editor);

  return (
    <div className={`${enabled ? "" : "plate-disabled"}`}>
      <ToolbarButton
        active={
          !!editor?.selection &&
          someNode(editor, { match: { type: ELEMENT_HANGING_INDENT } })
        }
        onMouseDown={
          editor ? getPreventDefaultHandler(toggleHangingIndent, editor) : undefined
        }
        {...props}
      />
    </div>
  );
};
